import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useParams } from "react-router";
import "./VolunteerPresent.scss";
import { Button, Layout, notification, Table } from "antd";

export const VolunteerPresent = () => {
  const { id } = useParams<{ id: string }>();
  const [items, setItems] = React.useState<any[]>([]);

  const { data, error, isFetching, isFetched, isError, refetch } = useQuery({
    queryKey: ["volunteerPresent", id],
    queryFn: async () => {
      const response = await fetch(`${process.env.REACT_APP_CLIENT_API}/pub/volunteer/${id}/present`);
      return response.json();
    },
  });

  const setLoading = (applicationId: string, participantId: string, loadingType: string, present: boolean) => {
    setItems((prev) => {
      return prev.map((item) => {
        if (item.applicationId === applicationId && item.participantId === participantId) {
          return { ...item, loadingType, present };
        }
        return item;
      });
    });
  };

  const onPresent = async ({ applicationId, participantId, present }: any, newPresent: boolean) => {
    setLoading(applicationId, participantId, `${newPresent}`, present);

    await fetch(`${process.env.REACT_APP_CLIENT_API}/volunteer/presence`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ applicationId, participantId, present: newPresent }),
    })
      .then(async (resp) => {
        let data = await resp.json();
        if (!resp.ok) {
          setLoading(applicationId, participantId, "", present);
          notification.error({ message: data.message });
        } else {
          setLoading(applicationId, participantId, "", newPresent);
        }
      })
      .catch((e) => {
        setLoading(applicationId, participantId, "", present);
        notification.error({ message: "Failed to update presence" });
      });
  };

  useEffect(() => {
    if (isFetched) {
      setItems(data.data.items);
    }
  }, [data]);

  const columns = [
    {
      title: "Participant name",
      key: "ParticipantName",
      dataIndex: "participantName",
      align: "center",
      width: "25%",
    },
    {
      title: data?.data?.isDeadlineMode ? "Deadline" : "Date",
      key: "date",
      dataIndex: "date",
      align: "center",
      width: "25%",
    },
    {
      title: data?.data?.isDeadlineMode ? "Hours" : "Time",
      key: "time",
      dataIndex: "time",
      align: "center",
      width: "25%",
      render: (times) => times.map((time) => <div key={time}>{time}</div>),
    },
    {
      title: "Be present or not",
      align: "center",
      width: "25%",
      render: (text, record) => (
        <div>
          <Button
            onClick={() => onPresent(record, false)}
            type={record.present === false ? "primary" : "default"}
            style={{ marginRight: 10 }}
            loading={record.loadingType === "false"}
            disabled={record.loadingType == "true"}
          >
            Not present
          </Button>
          <Button
            loading={record.loadingType === "true"}
            disabled={record.loadingType == "false"}
            onClick={() => onPresent(record, true)}
            type={record.present === true ? "primary" : "default"}
          >
            Present
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Layout className=" vol-container ">
      <div>
        <img src="/logo-big.png" alt="logo" />
      </div>
      <div style={{ paddingLeft: 80, paddingRight: 80 }}>
        {isFetching && !isFetched && (
          <div style={{ marginTop: 100, marginBottom: 40, fontSize: 18, textAlign: "center" }}>Loading...</div>
        )}

        {isError && <div>Error: {error.message}</div>}

        {isFetched && (
          <div>
            <div style={{ fontSize: 20, textAlign: "center", padding: 40 }}>
              Below are the volunteers who signed up for {data.data.title}, please help us mark whether the volunteers
              are present, thank you!
            </div>

            <Table
              size="small"
              pagination={false}
              rowKey={(r) => `${r.applicationId}_${r.participantId}`}
              columns={columns as any}
              dataSource={items}
            />
          </div>
        )}
      </div>
    </Layout>
  );
};
